/**
 * Application ID constants used throughout the Portal application.
 * These IDs should match the values in the Bridge Admin database.
 * Keep this file in sync with Portal/Constants/ApplicationIds.cs
 */
export const ApplicationIds = {
    /**
     * EVA / EventsAdmin application ID
     */
    EventsAdmin: 6,

    /**
     * Application ID that is filtered out from standard lists
     */
    FilteredApplication: 8,

    /**
     * Equip 2.0 application ID
     */
    Equip20: 100,

    Edrops : 2,
    Projects : 3,
    Ndt : 4,
    _3DView : 7,
} as const;
